export default "__VITE_ASSET__CtMuVrYG__"